import "./CartPage.css";
import CartTotalSection from "../PageElements/CartPageElements/CardTotalSection.jsx";
import CartBannerSection from "../PageElements/CartPageElements/CartBannerSection.jsx";

import { useCart } from "../Contexts/Cart.contexts.jsx";
import { FaTrash } from "react-icons/fa";

export default function CartPage() {
  const { cartItems, removeFromCart, clearCart } = useCart();

  const price = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );
  const discount =
    price === 0 ? 0 : price > 3000 ? 300 : price > 2000 ? 200 : 100;
  const tax = Math.round(price * 0.05);

  return (
    <>
      <CartBannerSection />

      <div className="cartContainer">
        {/* Header with Clear Cart Button */}
        <div className="cartHeader">
          <h2>{cartItems?.length} test(s) added</h2>

          {cartItems.length > 0 && (
            <button className="clearCartBtn" onClick={clearCart}>
              Clear All
            </button>
          )}
        </div>

        <div className="cartTableSection">
          <div className="cartTableLeft">
            {cartItems.length > 0 ? (
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Test Name</th>
                    <th>Price</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {cartItems.map((item) => (
                    <tr key={item.id}>
                      <td className="product-cell">{item.product}</td>
                      <td>₹{item.price}</td>

                      <td>
                        <FaTrash
                          className="remove-btn"
                          onClick={() => removeFromCart(item.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="defaultTable">No Test Package(s) Found</div>
            )}
          </div>

          <div className="cartTotalSection">
            <CartTotalSection
              price={price}
              discount={cartItems.length > 0 ? discount : 0}
              tax={tax}
            />
          </div>
        </div>
      </div>
    </>
  );
}
